import "./form-hidden-departure-picker.scss";
import { InputWrapper, Button } from "../../../components";
import { useCheckbox, useFormContext } from "../../../features/auto-form";
import { useEffect, useLayoutEffect, useState } from "react";
import { useTranslate } from "../../../features/translation/hooks/use-translation";
import SwitchInput from "../../../components/inputs/switch-input/switch-input";
import Checkbox from "../../../components/inputs/checkbox/checkbox";
import Divider from "../../../components/divider/divider";
const MARKETS = ["se", "dk", "no", "fi"];

// TODO: Fix monster component into more modual component without triggering re-rendering
const getMarket = (market) => {
  return market === "gb" ? "se" : market;
};

const AirportOptions = ({ options, name, onChange, selectedValues }) => {
  return (
    <div className="row">
      {options.map((option, i) => (
        <div
          className="col col-6 col-sm-4 col-md-3"
          key={`${name}-${option.value}-${i}`}
        >
          <Checkbox
            name={name}
            id={`${name}.${option.value}`}
            label={option.label}
            onChange={onChange}
            value={option.value}
            checked={selectedValues.includes(option.value)}
          />
        </div>
      ))}
    </div>
  );
};


const FormHiddenDeparturePicker = (props) => {
  const [displayAll, setDisplayAll] = useState(false);
  const [markets, setMarkets] = useState(MARKETS);
  const { t } = useTranslate();

  const { ref, bind } = useCheckbox(props);

  useEffect(() => {
    setMarkets(MARKETS.filter((o) => o !== getMarket(props.market)));
  }, [props.market]);


  const [textValue, setTextValue] = useState("");

  const { register, deregister, updateValidity } = useFormContext();

  useLayoutEffect(() => {
    if (!props.ignore) {
      // Register as ref in form on mount
      register(props.id || props.name, ref);

      // Deregister as ref in form on unmount
      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  useEffect(() => {
    let tempText = ``;
    if (bind.values && bind.values[0]) {
      tempText = bind.values.join(", ");
    }
    setTextValue(tempText);
  }, [bind.values]);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);

  const translatedLabel =
    t(`input.custom.hiddenDeparturePicker.label`) || props.label;

  const translatedPlaceholder =
    t(`input.custom.hiddenDeparturePicker.placeholder`) || props.placeholder;

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <InputWrapper
        {...props}
        label={translatedLabel}
        error={bind.error}
        displayError={bind.displayError}
        inputType="text"
        className={`${isOpen ? "active" : ""}`}
      >
        <div
          className="group input-hidden--field"
          data-label="input"
          onClick={() => {
            !props.disabled && setIsOpen(!isOpen);
          }}
        >
          {props.leadingIcon && (
            <span className="icon-leading">
              <span
                className="icon medium"
                style={{
                  WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.leadingIcon}.svg)`,
                  maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.leadingIcon}.svg)`,
                  color: "currentColor",
                }}
              ></span>
            </span>
          )}
          <input
            id={props.id || props.name}
            style={{
              cursor: "pointer",
              overflow: "hidden",
              textOverflow: "ellipsis", // Or replace "ellipsis" with your desired string
              whiteSpace: "nowrap",
            }}
            type="text"
            placeholder={translatedPlaceholder}
            value={textValue}
            readOnly
            disabled={props.disabled}
          />
          {bind.values.length > 0 && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                paddingRight: "var(--space-2)",
              }}
            >
              ({bind.values.length})
            </span>
          )}

          {props.trailingIcon && (
            <span className="icon-trailing">
              <span
                className="icon medium"
                style={{
                  WebkitMaskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.trailingIcon}.svg)`,
                  maskImage: `url(https://static.tui.com/assets/v2/icons/tui-light/${props.trailingIcon}.svg)`,
                  color: "currentColor",
                }}
              ></span>
            </span>
          )}
        </div>
      </InputWrapper>
      <div
        className="input-modal"
        style={{ overflowAnchor: "none !important" }}
      >
        <div
          className="input-modal--backdrop"
          hidden={!isOpen}
          onClick={() => setIsOpen(false)}
        />
        <div style={{ paddingLeft: "calc(50% - 0.75rem)" }} hidden={!isOpen}>
          <div className="input-modal--arrow" />
        </div>
        <div
          style={{
            position: "absolute",
            left: "0",
            right: "0",
            marginTop: "12px",
            minWidth: "50%",
            minHeight: "100vh",
          }}
        >
          <dialog
            className="input-dialog base "
            aria-modal="true"
            id={`dialog-${props.name}`}
            open={isOpen}
          >
            <form method="dialog" className="input-modal--content">
              <header className="content-header">
                <span className="title">
                  <p className="text lead medium semibold nospace ">
                    {translatedPlaceholder}
                  </p>
                </span>
                <span className="control">
                  <button
                    className="icon-button primary medium"
                    type="button"
                    onClick={() => setIsOpen(false)}
                    title="Icon Button"
                  >
                    <span
                      className="icon "
                      style={{
                        WebkitMaskImage:
                          "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)",
                        maskImage:
                          "url(https://static.tui.com/assets/v2/icons/tui-light/cross.svg)",
                        color: "currentColor",
                      }}
                    ></span>
                  </button>
                </span>
              </header>
              <section className="main">
              <div className="container form-hidden-departure-picker">
                <div className="row">
                  <div className="col-12">
                    <SwitchInput
                      name="displayAll"
                      label={t("input.custom.hiddenDeparturePicker.displayAll")}
                      value={displayAll}
                      onChange={(e) => setDisplayAll(e.target.checked)}
                    />
                  </div>
                </div>
                <div style={{ marginTop: "var(--space-4)" }}>
                  <AirportOptions
                    options={MARKETS.flatMap((mkt) =>
                      props.options[mkt].filter((o) => o.type === "primary")
                    )}
                    name={props.name}
                    onChange={bind.onChange}
                    selectedValues={bind.values}
                  />
                </div>
            
                <div className="row">
                  <div className="col col-12">
                    <Divider className="thin passive horizontal" />
                  </div>
                </div>
                <AirportOptions
                  options={props.options[getMarket(props.market)].filter(
                    (o) => o.type === "secondary"
                  )}
                  name={props.name}
                  onChange={bind.onChange}
                  selectedValues={bind.values}
                />
                <div hidden={!displayAll}>
                  {markets.map((mkt) => (
                    <div key={`external-market-${mkt}`}>
                      <div
                        className="row"
                        style={{
                          display: "flex",
                          width: "100%",
                          flexFlow: "column",
                          gap: "16px",
                          paddingTop: "var(--space-4)",
                        }}
                      >
                        <div className="col col-12">
                          <Divider
                            className="thin passive horizontal"
                            label={t(`general.names.country.${mkt}`)}
                          />
                        </div>
                      </div>
                      <AirportOptions
                        options={props.options[mkt].filter(
                          (o) => o.type === "secondary"
                        )}
                        name={props.name}
                        onChange={bind.onChange}
                        selectedValues={bind.values}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </section>
              <menu
                className="footer"
                style={{
                  display: "flex",
                  gap: "var(--space-4)",
                  justifyContent: "flex-end",
                }}
              >
                {props.onReset && (
                  <Button
                  label={t("input.button.reset")}
                    className="ghost medium"
                    onClick={() => {
                      props.onReset();
                    }}
                    style={{ border: 0, textDecoration: "underline" }}
                  />
                )}
                <Button
                  label={t("input.button.close")}
                  className="primary medium"
                  onClick={() => setIsOpen(false)}
                />
              </menu>
            </form>
          </dialog>
        </div>
      </div>
    </div>
  );
};

export default FormHiddenDeparturePicker;
